import React from 'react';

interface TimePickerIconProps {
  size?: number;
  color?: string;
}

/**
 * TimePicker Icon Component
 * @description A clock icon used for time picker inputs
 */
export const TimePickerIcon: React.FC<TimePickerIconProps> = ({
  size = 20,
  color = '#000',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        fill={color}
        d="M10.313 2.188a8.125 8.125 0 1 1 0 16.25 8.125 8.125 0 0 1 0-16.25m0 .855a7.27 7.27 0 1 0 0 14.54 7.27 7.27 0 0 0 0-14.54m-.428 2.566h.855v4.635l4.02 2.318-.428.744-4.447-2.566z"
      />
    </svg>
  );
};

export default TimePickerIcon;

